import { useEffect, useState } from "react";
import { Composite, useCompositeState } from "reakit/Composite";

import SimpleMenuNavigationItem from "./SimpleMenuNavigationItem";
import { useWindowSize } from "../../Utils/useWindowResizedEffect";

const SimpleMenuNavigationItemDropdownMenu = props => {
  const { primaryColor, childrenItems, onClick, onKeyDown, shouldFocusSubMenu } = props;

  const [offsetTop, setOffsetTop] = useState(0);
  const [dropdownNode, setDropdownNode] = useState();

  const { windowHeight } = useWindowSize();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (dropdownNode) setOffsetTop(dropdownNode.offsetTop);
  });

  useEffect(() => {
    if (!shouldFocusSubMenu || !dropdownNode) return;

    const activeLinkNode = dropdownNode.querySelector(".nav-link[tabindex='0']");

    if (activeLinkNode) activeLinkNode.focus();
  }, [dropdownNode, shouldFocusSubMenu]);

  const compositeState = useCompositeState({ orientation: "vertical" });

  const maxHeight = windowHeight ? windowHeight - offsetTop : null;

  return (
    <div className="dropdown-menu" ref={setDropdownNode} style={{ maxHeight }}>
      <Composite as="ul" className="list-unstyled">
        {maxHeight &&
          childrenItems.map(navigationItem => (
            <SimpleMenuNavigationItem
              key={navigationItem.id}
              navigationItem={navigationItem}
              onClick={onClick}
              primaryColor={primaryColor}
              compositeState={compositeState}
              onKeyDown={onKeyDown}
            />
          ))}
      </Composite>
    </div>
  );
};

export default SimpleMenuNavigationItemDropdownMenu;
